import { PermissionType } from "@store/session/types";
import { API } from "aws-amplify";

async function listPermissionsForStream(userId: string, companyId: string, siteId: string, kvsName: string): Promise<{ kvsName: string, permissions: PermissionType[] }> {
  try {
    const path: string = `/permissions/${userId}/${companyId}/${siteId}/${kvsName}`;
    const service: string = `api-service`;

    const data = await API.get(
      service,
      path,
      {}
    );

    const result = Object.keys(data.data).map((key) => {
      return {
        kvsName: key,
        permissions: data.data[key]
      }
    })

    if (result[0]) return result[0]

    return { kvsName, permissions: [] }
  } catch (error: any) {
    throw error;
  }
}

export default listPermissionsForStream;
